import { PARAMETERS_STORAGE_KEY, SESSION_STORAGE_KEY, domain, headers } from "../../utils/config";
import { authenticationAction } from "../reducers/auth-slice";
import { profileAction } from "../reducers/profile-slice";
import { saveSessionToStorage } from "../../utils/session";

export const authentication = (credential) => {
    return async (dispatch) => {
        dispatch(
            authenticationAction.authenticationDetails({
                data:{},
                status: "pending"
            })
        );
        const fetchAuthData = async () => {
            const response = await fetch(domain+'auth-api/authenticate-token', {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(credential)
            });
    
            if(!response.ok){
                throw new Error('Could not able to do the authentication!');
            }
            const data = await response.json();
            return data;
        }

        try{
            const authData = await fetchAuthData();
            saveSessionToStorage(authData.content);
            // dispatch(profileDetailsAction(authData.content.access_token));
            dispatch(authenticationAction.authenticationDetails({
                data: authData.content,
                status: "success"
            }));
        }catch(error){
            dispatch(
                authenticationAction.authenticationDetails({
                    data:{},
                    status: "fail"
                })
            );
            window.location.href= "/login";
        }
        
    };
};

export const profileDetailsAction = (token) => {
    const myHeaders = {
        'authorization': 'Bearer '+token,
    }
    return async (dispatch) => {
        const fetchProfileData = async () => {
            const response = await fetch(domain+'core-api/profile', {
                method: 'GET',
                headers: myHeaders,
            });
    
            if(!response.ok){
                throw new Error('Could not able to do the authentication!');
            }
            const data = await response.json();
            return data;
        }

        try{
            const profileData = await fetchProfileData();
            dispatch(profileAction.profileDetails(profileData.content.contact));
        }catch(error){
            console.error("Error on Profile API Call!");
            return;
        }
        
    };
}


export const authenticationRefresh = (credential) => {
    return async (dispatch) => {
        dispatch(
            authenticationAction.authenticationDetails({
                data:{},
                status: "pending"
            })
        );
        const fetchAuthRefreshData = async () => {
            const response = await fetch(domain+'auth-api/refresh-token', {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(credential)
            });
    
            if(!response.ok){
                throw new Error('Could not able to do the authentication Refresh Token!');
            }
            const data = await response.json();
            return data;
        }

        try{
            const authData = await fetchAuthRefreshData();
            saveSessionToStorage(authData.content);
            dispatch(authenticationAction.authenticationDetails({
                data: authData.content,
                status: "success"
            }));
        }catch(error){
            console.error("Error on Refresh API Call!");
            localStorage.removeItem(SESSION_STORAGE_KEY);
            localStorage.removeItem(PARAMETERS_STORAGE_KEY);
            window.location.href= "/login";
        }
        
    };
};